import { isAxiosError } from "axios";
import axiosInstance from "../../utility/axiosInstance";

import {
  deleteAssessment,
  deleteJob,
  deletePretest,
  setLoading,
} from "../../store/slices/job";
// import { setMessage } from "../../store/slices/message";
import { stopLoading } from "../../store/slices/loading";
import {
  GetAllJobsQuery,
  GetAllJobsResponse,
  IJob,
  JobCreation,
  QuestionCreation,
  RubricResponse,
} from "../../store/types/job";
import { toast } from "sonner";
import { setMessage } from "../../store/slices/message";
import { AppDispatch } from "../../store";

// const API_URL = "/api/v1";

type IGetJobs = (dispatch: any) => Promise<void>;
export const getJobss: IGetJobs = async (dispatch: any) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.get("/job");

    return response.data;
  } catch (error) {
    if (isAxiosError(error)) {
    }
  }
  dispatch(setLoading());
};

export const getJobs = async (
  query?: GetAllJobsQuery,
): Promise<GetAllJobsResponse> => {
  const response = await axiosInstance.get(`/job`);
  // ?${params.toString()}
  return response.data;
};

// export const getOrderById = async (id: string): Promise<GetOrderResponse> => {
//   const response = await axiosInstance.get(`${API_URL}/orders/${id}`);
//   return response.data;
// };

export const getRubrics = async (): Promise<RubricResponse> => {
  const response = await axiosInstance.get<RubricResponse>("/rubrics");
  return response.data;
};

type JobType = (dispatch: any, formData: JobCreation) => Promise<void>;
export const jobs: JobType = async (dispatch, formData) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post("/job/createjob", formData);

    if (response.data?.message === "job already exist!") {
      throw new Error(response.data?.message);
    } else {
      dispatch(
        setMessage({
          type: "success",
          message: "Job created successfully",
          title: "Job Created",
        }),
      );

      toast.success("Job created successfully");

      // Return the response data if needed for further processing
      return response.data;
    }
  } catch (error) {
    if (isAxiosError(error)) {
      // Extract the specific error message from the nested error object
      const errorMessage =
        error?.response?.data?.error?.message || // Specific error message
        error?.response?.data?.message || // General message
        "Failed to create job";

      toast.error(errorMessage);
      dispatch(
        setMessage({
          type: "error",
          message: errorMessage,
          title: "Failed",
        }),
      );
    }
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

// Create Pretest
type PretestType = (dispatch: any, formData: QuestionCreation) => Promise<void>;
export const pretest: PretestType = async (dispatch, formData) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/admin/create-pretest",
      formData,
    );

    if (response.data?.message === "Pretest already exist!") {
      throw new Error(response.data?.message);
    } else {
      dispatch(
        setMessage({
          type: "success",
          message: "Pretest created successfully",
          // message: response?.data?.message,
          title: "Pretest Created",
        }),
      );

      toast.success("Pretest created successfully");

      // Return the response data if needed for further processing
      return response.data;
    }
  } catch (error) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
    } else {
      // dispatch(toast.error("An unexpected error occurred"));
    }
    // Re-throw the error so the calling function knows it failed
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

// Create Assessment
type AssessmentType = (
  dispatch: any,
  formData: QuestionCreation,
) => Promise<void>;
export const assessment: AssessmentType = async (dispatch, formData) => {
  dispatch(setLoading());
  try {
    const response = await axiosInstance.post(
      "/admin/create-assessment",
      formData,
    );

    if (response.data?.message === "Assessment already exist!") {
      throw new Error(response.data?.message);
    } else {
      dispatch(
        setMessage({
          type: "success",
          message: "Assessment created successfully",
          // message: response?.data?.message,
          title: "Assessment Created",
        }),
      );

      toast.success("Assessment created successfully");

      // Return the response data if needed for further processing
      return response.data;
    }
  } catch (error) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
    } else {
      // dispatch(toast.error("An unexpected error occurred"));
    }
    // Re-throw the error so the calling function knows it failed
    throw error;
  } finally {
    dispatch(stopLoading());
  }
};

// Delete Pretest
export const delete_pretest = async (
  dispatch: AppDispatch,
  id: string,
  navigate: Function,
): Promise<void> => {
  try {
    const handleSuccess = async () => {
      navigate("/pretests");
      // Small delay to ensure navigation happens before reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    };
    const response = await axiosInstance.delete(`/admin/pretest/${id}`);

    const { data } = response.data;
    dispatch(deletePretest(data));
    toast.success(response.data?.message);
    dispatch(
      setMessage({
        message: "Pretest deleted successfully",
        // message: response.data?.message,
        type: "success",
        title: "Successful",
      }),
    );
    navigate(`/pretests`);
    handleSuccess();
  } catch (error: any) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
      dispatch(
        setMessage({
          message: error?.response?.data?.message,
          type: "error",
          title: "Failed",
        }),
      );
    }
  }
};

// Delete Assessment
export const delete_assessment = async (
  dispatch: AppDispatch,
  id: string,
  navigate: Function,
): Promise<void> => {
  try {
    const handleSuccess = async () => {
      navigate("/assessments");
      // Small delay to ensure navigation happens before reload
      setTimeout(() => {
        window.location.reload();
      }, 100);
    };
    const response = await axiosInstance.delete(`/admin/assessment/${id}`);

    const { data } = response.data;
    dispatch(deleteAssessment(data));
    toast.success(response.data?.message);
    dispatch(
      setMessage({
        message: "Assessment deleted successfully",
        // message: response.data?.message,
        type: "success",
        title: "Successful",
      }),
    );
    navigate(`/assessments`);
    handleSuccess();
  } catch (error: any) {
    if (isAxiosError(error)) {
      toast.error(error?.response?.data?.message);
      dispatch(
        setMessage({
          message: error?.response?.data?.message,
          type: "error",
          title: "Failed",
        }),
      );
    }
  }
};

// Edit Jobs
type EditJobType = (
  dispatch: any,
  formData: IJob,
  applyToPending?: boolean,
) => Promise<{ success: boolean; message: string }>;

export const editJob: EditJobType = async (
  dispatch,
  formData,
  applyToPending = false,
) => {
  dispatch(setLoading());

  try {
    const { id, ...rest } = formData;
    const jobId = id;

    // Transform interview questions to match backend expectations
    const payload = {
      ...rest,
      interviewQuestions: rest.interviewQuestions.map((q) => ({
        question: q.question,
        ...(q.id && { id: q.id }), // Include id if it exists for updates
      })),
    };

    // Use the new endpoint with pending parameter
    const response = await axiosInstance.put(
      `/job/${jobId}/interview?pending=${applyToPending}`,
      payload,
    );

    if (response.status >= 200 && response.status < 300) {
      dispatch(
        setMessage({
          type: "success",
          message: response.data?.message || "Job updated successfully",
          title: "Job Updated",
        }),
      );
      toast.success("Job updated successfully");
      return { success: true, message: response.data?.message };
    } else {
      throw new Error(response.data?.message || "Failed to update job");
    }
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error?.message ||
      error.message ||
      "An error occurred while updating the job";

    dispatch(
      setMessage({
        type: "error",
        message: errorMessage,
        title: "Update Failed",
      }),
    );
    toast.error(errorMessage);

    return { success: false, message: errorMessage };
  } finally {
    dispatch(stopLoading());
  }
};

export const delete_job = async (
  dispatch: AppDispatch,
  id: string,
  onSuccess?: () => void,
): Promise<void> => {
  try {
    const response = await axiosInstance.delete(`/job/${id}`);

    const { data } = response.data;
    dispatch(deleteJob(data));
    toast.success(response.data?.message || "Job deleted successfully");
    dispatch(
      setMessage({
        message: "Job Deleted Successfully",
        type: "success",
        title: "Successful",
      }),
    );

    // Call the onSuccess callback if provided to refetch data
    if (onSuccess) {
      onSuccess();
    }
  } catch (error: any) {
    if (isAxiosError(error)) {
      const errorMessage =
        error?.response?.data?.message || "Failed to delete job";
      toast.error(errorMessage);
      dispatch(
        setMessage({
          message: errorMessage,
          type: "error",
          title: "Failed",
        }),
      );
    }
    throw error;
  }
};

// Edit Pretest
type EditPretestType = (
  dispatch: any,
  id: string,
  formData: QuestionCreation,
) => Promise<{ success: boolean; message: string }>;

export const edit_pretest: EditPretestType = async (dispatch, id, formData) => {
  dispatch(setLoading());

  try {
    const response = await axiosInstance.patch(
      `/admin/pretest/${id}`,
      formData,
    );

    if (response.status >= 200 && response.status < 300) {
      dispatch(
        setMessage({
          type: "success",
          message: response.data?.message || "Pretest updated successfully",
          title: "Pretest Updated",
        }),
      );
      toast.success("Pretest updated successfully");
      return { success: true, message: response.data?.message };
    } else {
      throw new Error(response.data?.message || "Failed to update pretest");
    }
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error?.message ||
      error.message ||
      "An error occurred while updating the pretest";

    dispatch(
      setMessage({
        type: "error",
        message: errorMessage,
        title: "Update Failed",
      }),
    );
    toast.error(errorMessage);

    return { success: false, message: errorMessage };
  } finally {
    dispatch(stopLoading());
  }
};

// Edit Assessment
type EditAssessmentType = (
  dispatch: any,
  id: string,
  formData: QuestionCreation,
) => Promise<{ success: boolean; message: string }>;

export const edit_assessment: EditAssessmentType = async (
  dispatch,
  id,
  formData,
) => {
  dispatch(setLoading());

  try {
    const response = await axiosInstance.patch(
      `/admin/assessment/${id}`,
      formData,
    );

    if (response.status >= 200 && response.status < 300) {
      dispatch(
        setMessage({
          type: "success",
          message: response.data?.message || "Assessment updated successfully",
          title: "Assessment Updated",
        }),
      );
      toast.success("Assessment updated successfully");
      return { success: true, message: response.data?.message };
    } else {
      throw new Error(response.data?.message || "Failed to update assessment");
    }
  } catch (error: any) {
    const errorMessage =
      error.response?.data?.message ||
      error.response?.data?.error?.message ||
      error.message ||
      "An error occurred while updating the assessment";

    dispatch(
      setMessage({
        type: "error",
        message: errorMessage,
        title: "Update Failed",
      }),
    );
    toast.error(errorMessage);

    return { success: false, message: errorMessage };
  } finally {
    dispatch(stopLoading());
  }
};

// Get Pretest By ID
export const getPretestById = async (id: string): Promise<QuestionCreation> => {
  const response = await axiosInstance.get(`/admin/pretest/${id}`);
  return response.data?.data || response.data;
};

// Get Assessment By ID
export const getAssessmentById = async (
  id: string,
): Promise<QuestionCreation> => {
  const response = await axiosInstance.get(`/admin/assessment/${id}`);
  return response.data?.data || response.data;
};
